var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "39px",
    viewBox: "0 0 29 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "#3d4146",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.14689254,20.111573 C0.382293677,18.3093087 0,16.4319776 0,14.4795196 C0,12.5270616 0.382293677,10.6497185 1.14689254,8.84745417 C1.84322391,7.14076115 2.87405135,5.59793539 4.23940697,4.21891697 C5.56380057,2.89453296 7.09980272,1.87052434 8.84745657,1.1468911 C10.6224192,0.382285049 12.4997504,0 14.4795196,0 C16.5002496,0 18.3844116,0.382285049 20.1320654,1.1468911 C21.8660577,1.87052434 23.4020646,2.89453296 24.7401102,4.21891697 C26.105467,5.58427379 27.1431253,7.12709955 27.8531089,8.84745417 C28.617703,10.6497185 29,12.5270616 29,14.4795196 C29,16.4319776 28.617703,18.3093087 27.8531089,20.111573 C27.361579,21.2175153 26.8563995,22.132291 26.3375704,22.8559243 L16.7528214,37.4173667 C16.1247594,38.3731153 15.3738269,38.8509824 14.5,38.8509824 C13.6261731,38.8509824 12.8684098,38.3731153 12.2266982,37.4173667 L2.66242962,22.8559243 C2.03436644,21.9820974 1.52919173,21.0673216 1.14689254,20.111573 ",
    id: 4,
    fill: "#373B40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleMarkIcon);
export default __webpack_public_path__ + "static/media/purple_mark_icon.a8747d863d8219320f6538c87de33465.svg";
export { ForwardRef as ReactComponent };